export default __webpack_public_path__ + "f5294ec2fb923d238f8ea415084a8738.svg";